// React Query keys per domain. Root segments must match EVENT_INVALIDATION in events.ts.
export const qk = {
  me: ['me'] as const,
  myWorkspaces: ['my-workspaces'] as const,
  workspace: (slug: string) => ['workspace', slug] as const,
  members: (slug: string) => ['members', slug] as const,
  presence: (slug: string) => ['presence', slug] as const,
  presenceBriefs: (slug: string) => ['presence', slug, 'briefs'] as const,
  deputyActions: (slug: string, all: boolean) => ['presence', slug, 'deputy-actions', all] as const,
  invitations: (slug: string) => ['members', slug, 'invitations'] as const,
  divisions: (slug: string) => ['divisions', slug] as const,
  issues: (slug: string, params: Record<string, unknown> = {}) => ['issues', slug, params] as const,
  issue: (slug: string, key: string) => ['issue', slug, key] as const,
  myIssues: (slug: string, tab: string) => ['my-issues', slug, tab] as const,
  comments: (slug: string, issueId: string) => ['comments', slug, issueId] as const,
  activity: (slug: string, issueId: string) => ['activity', slug, issueId] as const,
  projects: (slug: string) => ['projects', slug] as const,
  project: (slug: string, id: string) => ['project', slug, id] as const,
  inbox: (slug: string, filter: string = 'all') => ['inbox', slug, filter] as const,
  agents: (slug: string) => ['agents', slug] as const,
  agent: (slug: string, id: string) => ['agent', slug, id] as const,
  tasks: (slug: string, params: Record<string, unknown> = {}) => ['tasks', slug, params] as const,
  task: (slug: string, id: string) => ['task', slug, id] as const,
  approvals: (slug: string, status: string = 'pending') => ['approvals', slug, status] as const,
  approval: (slug: string, id: string) => ['approval', slug, id] as const,
  chatSessions: (slug: string) => ['chat', slug, 'sessions'] as const,
  chatSession: (slug: string, id: string) => ['chat', slug, 'session', id] as const,
  channels: (slug: string) => ['channels', slug] as const,
  channel: (slug: string, id: string) => ['channel', slug, id] as const,
  channelMessages: (slug: string, id: string, parentId?: string | null) => ['channel', slug, id, 'messages', parentId ?? null] as const,
  autopilots: (slug: string) => ['autopilots', slug] as const,
  autopilot: (slug: string, id: string) => ['autopilot', slug, id] as const,
  squads: (slug: string) => ['squads', slug] as const,
  skills: (slug: string) => ['skills', slug] as const,
  memory: (slug: string) => ['memory', slug] as const,
  usage: (slug: string, range: string = '30d') => ['usage', slug, range] as const,
  search: (slug: string, q: string) => ['search', slug, q] as const,
  // Platform admin console (`/admin`) — cross-tenant, so these keys carry no workspace slug.
  adminOverview: ['admin', 'overview'] as const,
  adminUsers: (q: string, test: boolean) => ['admin', 'users', q, test] as const,
  adminWorkspaces: (q: string, test: boolean) => ['admin', 'workspaces', q, test] as const,
  adminPayments: (status: string) => ['admin', 'payments', status] as const,
  adminSessions: (all: boolean, test: boolean) => ['admin', 'sessions', all, test] as const,
  adminAudit: (q: string) => ['admin', 'audit', q] as const,
}
